const WALLPAPERS = [
  {
    version: "Topaz",
    wallpapers: [
      {
        name: "Supernova",
        imageUrl: "supernova.jpg"
      }
    ]
  },
  {
    version: "Sapphire",
    wallpapers : [
      {
        name: "Meteor Abyss",
        imageUrl: "meteor_abyss.jpg"
      },
      {
        name: "Rushing Stream",
        imageUrl: "rushing_stream.jpg"
      }
    ]
  },
  {
    version: "Ruby",
    wallpapers : [
      {
        name: "Storm",
        imageUrl: "storm.jpg"
      },
      {
        name: "Supersaturation",
        imageUrl: "supersaturation.jpg"
      },
      {
        name: "Saturated Stream",
        imageUrl: "saturated_stream.jpg"
      },
      {
        name: "Polka",
        imageUrl: "polka.jpg"
      }
    ]
  },
  {
    version: "Quartz",
    wallpapers : [
      {
        name: "Crystal Canyons",
        imageUrl: "crystal_canyons.jpg"
      },
      {
        name: "Crystal Canyons Alt.",
        imageUrl: "crystal_canyons_alt.jpg"
      },
      {
        name: "Refract",
        imageUrl: "refract.jpg"
      },
      {
        name: "Liquid Quartz",
        imageUrl: "liquid_quartz.jpg"
      },
      {
        name: "Shimmer",
        imageUrl: "shimmer.jpg"
      }
    ]
  }
];

module.exports = WALLPAPERS;